import { render, staticRenderFns } from "./rightAside.vue?vue&type=template&id=7128814b&scoped=true"
import script from "./rightAside.vue?vue&type=script&lang=js"
export * from "./rightAside.vue?vue&type=script&lang=js"
import style0 from "./rightAside.vue?vue&type=style&index=0&id=7128814b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7128814b",
  null
  
)

export default component.exports